import React from 'react';

const QuestionIdComposed = ({questionId, optionId}) => (
    <>
        <span className="question-id">{questionId}</span>
        <span>.</span>
        <span className="option-id">{optionId}</span>
    </>
);

export default QuestionIdComposed;
